{
  "journalAudit.action.referentiel.published": "Révision du référentiel publiée",
  "journalAudit.action.taxonomy.axis_correction_submitted": "Correction d’un axe soumise à la validation"
}
